import dayjs from "dayjs";

// Axis ticks stay compact; the hover tooltip adds the weekday.
export function formatAxisDate(value: string, location: "tick" | "tooltip" | string): string {
  return dayjs(value).format(location === "tooltip" ? "MMM DD, ddd" : "MMM DD");
}
